import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useModal } from './useModal';

const TextWrapper = styled.p``;

interface Props {
    header?: string | React.JSX.Element;
    message?: string | React.JSX.Element;
    footer?: string | React.JSX.Element;
}

export const useConfirmedAction = (options: Props = {}) => {
    const { t } = useTranslation('common');
    const [setModal, resetModal] = useModal();
    const { header, message, footer } = options;

    const confirmedAction = (action: () => void, active: boolean = true) => {
        if (!active) {
            action();
            return;
        }

        setModal({
            toFront: true,
            title: header || t('confirmation.title'),
            content: (
                <>
                    {message ? (
                        typeof message === 'object' ? (
                            message
                        ) : (
                            <TextWrapper>{message}</TextWrapper>
                        )
                    ) : (
                        <TextWrapper>{t('confirmation.defaultMessage')}</TextWrapper>
                    )}
                    {footer || (
                        <div className="tw-flex tw-justify-between">
                            <Button className="!tw-bg-error tw-py-5" onPress={resetModal}>
                                {t('actions.cancel')}
                            </Button>
                            <Button
                                className="tw-py-5"
                                onPress={() => {
                                    action();
                                    resetModal();
                                }}
                            >
                                <FontAwesomeIcon icon={faCheck} />
                                <span className="tw-ml-2">{t('actions.confirm')}</span>
                            </Button>
                        </div>
                    )}
                </>
            ),
            show: true
        });
    };

    return confirmedAction;
};
